import { useState, useCallback } from "react";
import api from "@/lib/api";

/**
 * Upload a File object to /api/files/upload. Returns {id, url, size, content_type}.
 * @param {"foto_santri"|"foto_ustaz"|"dokumen"|"generic"} kind
 */
export async function uploadFile(file, kind = "generic") {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(`/files/upload?kind=${encodeURIComponent(kind)}`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

/**
 * React hook that turns a `/api/files/{id}/download` URL into a blob URL usable in <img src>.
 * `filePath` may be either a full download URL (returned by upload) or a plain http(s):// URL.
 */
export function useFileBlob(filePath) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!filePath) { setBlobUrl(null); return; }
    // If it's already a plain data: or absolute URL (http/https not our API), pass through
    if (filePath.startsWith("data:") || (filePath.startsWith("http") && !filePath.includes("/api/files/"))) {
      setBlobUrl(filePath); return;
    }
    setLoading(true);
    try {
      const res = await api.get(filePath.startsWith("/api") ? filePath.replace(/^\/api/, "") : filePath, {
        responseType: "blob",
      });
      const url = URL.createObjectURL(res.data);
      setBlobUrl(url);
    } finally { setLoading(false); }
  }, [filePath]);

  return { blobUrl, loading, load };
}
